exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-spinnerWrapper-3kzHVc3q {\n  margin: 0 auto;\n}\n.styles-circularSpinner-2N-2ssoK {\n  animation: styles-rotation-kQf_SS0b 1s ease-in infinite;\n}\n@keyframes styles-rotation-kQf_SS0b {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.styles-spinnerInCenter-2vVAeeXW {\n  position: absolute;\n  top: 49%;\n  left: 48%;\n}\n", ""]);

// exports
exports.locals = {
	"spinnerWrapper": "styles-spinnerWrapper-3kzHVc3q",
	"circularSpinner": "styles-circularSpinner-2N-2ssoK",
	"rotation": "styles-rotation-kQf_SS0b",
	"spinnerInCenter": "styles-spinnerInCenter-2vVAeeXW"
};